import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_filter_button = _resolveComponent("g-filter-button");
    return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
        return (_openBlock(), _createBlock(_component_g_filter_button, {
            filter: filter,
            onApplyFilter: _ctx.onFilterApply,
            class: "pb-2 pe-2"
        }, null, 8, ["filter", "onApplyFilter"]));
    }), 256));
}
